export default __webpack_public_path__ + "static/8_25-91c23d5cd98c0d9589d0d04c7a1489d5.png";